<template lang="pug">
  include ../../../../../views/desktop/shared/iconMixins.pug
  .edit-auto-delivery.xs-12
    SectionBlock.subscription-product-wrap.no-space-section
      BackButton(:url="backUrl").xs-hide.sm-hide
      .row
        transition(name="fade")
          .sub-wrap.xs-12(v-if="sub.id")
            .xs-12.md-4
              BackButton(:url="backUrl").secondary-back.md-hide.lg-hide
              ProductInfoImage(:imagery="sub.product_info.imagery")

            .product-info-wrap.xs-12.md-8
              .image-overlay.md-hide.lg-hide.xs-12
              .sub-product.xs-12.lg-10
                .xs-8
                  .upper.bold.xs-f-small.lg-f-medium.max-at-tweak.mg-bottom {{ sub.product_type_display_name }}
                  p.xs-f-small.lg-f-small.max-at-tweak(data-mr-ass="sub-color-name") {{ sub.product }}

                .xs-4.frequency-wrap
                  p.xs-f-xsmall.sm-f-small.lg-f-small.max-at-tweak.mg-bottom Ships every
                  .bold.xs-f-small.lg-f-medium.max-at-tweak(data-mr-ass="weekly-freq") {{ sub.frequency }} weeks

                hr.xs-12

              .attachments.xs-12.lg-10
                transition-group.xs-12(name="fade" tag="div")
                  SubAttachment(v-for="item in sub.attachments" :attachment="item" :key="item.id")

              .next-shipments.xs-12.lg-10.text-center.flex-box(v-if="!sub.inactive")
                .flex-1
                  p.next-shipments-title.inline-block.color-slate.upper.xs-f-xxsmall.lf-f-xsmall.max-at-tweak
                    | Next
                    br
                    |  Shipments

                .shipment-date.flex-1(v-for="nextDate in nextShipDates" data-mr-ass="shipment-dates")
                  p.inline-block
                    span.xs-f-xsmall.lg-f-small.max-at-tweak.color-slate {{ [nextDate, "YYYY-MM-DD"] | moment('MMMM') }}
                    br
                    span.xs-f-medium.lg-f-xmedium.max-at-tweak.bold  {{ [nextDate, "YYYY-MM-DD"] | moment("DD") }}

              .shipping-details.xs-12(v-if="sub.inactive")
                .ship-detail-title.xs-12.xs-f-small.lg-f-medium.bold.upper.max-at-tweak.text-center Shipping Details
                .xs-12.md-5
                  dropdown(label="Ships Every" v-model="reactivateFrequency").mr-5
                    option(v-for="num in frequencies" :value="num" :key="num") {{ num }} weeks

                .xs-12.md-7
                  .reactivate-next.text-center
                    p Shipping date:&nbsp;
                      span.bold(v-if="sub.inactive") {{ reactivateNext | moment('MMMM DD, YYYY') }}
                      span.bold(v-else) {{ sub.next | moment('MMMM DD, YYYY') }}
                  .more-cta-wrap.xs-12.text-center
                    button.more-cta.transparent-btn.xs-f-small.max-at-tweak(type="button" @click="showMoreOptions = !showMoreOptions" :class="{open: showMoreOptions}")
                      | More Options&nbsp;
                      span.icon-caret-down.xs-f-medium.max-at-tweak

                .xs-12
                  NextDateSelector(:subId="sub.id" :nextDate="reactivateNext" @onDateSelect="setReactivateShipDate" :toggle="showMoreOptions").xs-12

          .sub-wrap(v-else)
            p.text-center Subscription not found

    .row(v-if="!sub.inactive")
      .action-section.xs-f-small.lg-f-small.max-at-tweak
        .action-block(@click="shipNow({ subId: sub.id })" data-mr-ass="ship-now")
          i.icon-truck.xs-f-large.lg-f-xlarge.max-at-tweak
          p Ship Now

        .action-block(@click="openPostponeModal({ subId: sub.id })" data-mr-ass="postpone-delivery")
          i.icon-subscription.xs-f-large.lg-f-xlarge.max-at-tweak
          p Postpone Next
          p Delivery

        .action-block(@click="editAutoDeliveryFrequencyModal({ subId: sub.id })" data-mr-ass="change-frequency")
          i.icon-calendar.xs-f-large.lg-f-xlarge.max-at-tweak
          p Change
          p Frequency

        .action-block(v-if="sub.colorEditable" @click="openChangeColorModal()" data-mr-ass="change-color-button")
          +icon-color-kit.xs-f-large.lg-f-xlarge.max-at-tweak
          p Change Color

    SectionBlock
      .row
        .xs-12.md-6.sub-ship-address
          .xs-12.xs-f-small.lg-f-medium.bold.upper.max-at-tweak.text-center.address-title Shipping Address
          transition(name="fade")
            .xs-12(v-if="address.id")
              .md-2.xs-hide.sm-hide
              .xs-12.sm-12.md-9.lg-8
                Address(:address="address" edit=true :edit-method="openEditAddressModal")

        .xs-12.md-6
          .xs-12.xs-f-small.lg-f-medium.bold.upper.max-at-tweak.text-center.payment-title Payment Method
          transition(name="fade")
            .xs-12(v-if="payment && payment.paymentProfileId")
              .md-1.lg-1.xs-hide.sm-hide
              .xs-12.sm-12.md-11.lg-10
                PaymentProfile(:profile="payment" edit=true :edit-method="openEditPaymentModal")

      .row(v-if="sub.inactive")
        .reactivate-wrap.xs-12.text-center
          hr.xs-12
          button.reactivate-cta.mr-btn.xs-f-xsmall.max-at-tweak(@click="reactivateSubscription" :class="{ 'disabled': savingSub }" data-mr-ass="reactivate-button") reactivate subscription

    template(v-if="!sub.inactive")
      template(v-if="sub.product_type == 'color_kit'")
        SectionLink(:url="cancelLink" link-text="Cancel Subscription" data-mr-ass="cancel-sub-button")

      template(v-else)
        SectionLink(url="" @sectionLinkClick="enterCancelFlowv1()" link-text="Cancel Subscription" data-mr-ass="cancel-sub-button")

    SectionBlock(v-if="sub.inactive && memberBenefits && memberBenefits.length" no-padding=true)
      .row
        BenefitsTable(:membership-benefits="memberBenefits" :one-time-benefits="oneTimeBenefits")

    ExpertiseIncluded
</template>

<script>
  import { getShortDateString } from "../../../../utilities/mrVueUtils";
  import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
  import SectionBlock from '../../SectionBlock';
  import SectionLink from '../../SectionLink';
  import ExpertiseIncluded from '../../../ExpertiseIncluded';
  import BackButton from "../../BackButton";
  import ProductInfoImage from '../ProductInfoImage';
  import PaymentProfile from "../../../PaymentProfiles/PaymentProfile";
  import Address from "../../../AddressBook/Address";
  import BenefitsTable from "../../BenefitsTable";
  import NextDateSelector from "../NextDateSelector";

  export default {
    name: "EditAutoDeliveryDashboard",

    data() {
      return {
        backUrl: "/dashboard/purchases",
        showMoreOptions: false,
        reactivateFrequency: null,
        reactivateNext: null,
        openChangeColorFromUrlParam: false
      }
    },

    components: {
      'SubAttachment': () => import('./SubAttachment'),
      NextDateSelector,
      BenefitsTable,
      Address,
      PaymentProfile,
      BackButton,
      SectionBlock,
      SectionLink,
      ExpertiseIncluded,
      ProductInfoImage
    },

    computed: {
      ...mapState('customer', ['cdata']),
      ...mapState('subscriptions', ['savingSub']),

      ...mapGetters('subscriptions', ['getSubById']),
      ...mapGetters('addressBook', ['getAddressById']),
      ...mapGetters('payments', [
        'getPaymentProfileById',
        'profileIsEditable',
        'defaultPaymentProfile'
      ]),

      cancelLink() {
        return `/dashboard/purchases/edit-auto-delivery/${this.sub.id}/cancel-reasons`;
      },

      sub() {
        let sub = this.getSubById(this.$route.params.subId);

        if (sub.inactive) {
          this.reactivateNext = this.reactivateNext || sub.next;

          if (new Date(this.reactivateNext) < new Date()) {
            this.reactivateNext = new Date();
          }

          if (!sub.payment_id) {
            sub.payment_id = 1
          }

          this.reactivateFrequency = this.reactivateFrequency || sub.frequency;
        }

        return sub;
      },

      changeColorTheme() {
        if (this.sub && this.sub.product_info && this.sub.product_info.product_type == 'color_kit') {
          return 'try-it-on-modal';
        }
        return 'default';
      },

      address() {
        return this.getAddressById(this.sub.shipping_address_id);
      },

      payment() {
        let payment = this.getPaymentProfileById(this.sub.payment_id);
        if (!payment || !payment.paymentProfileId) {
          payment = this.defaultPaymentProfile;
        }

        return payment;
      },

      memberBenefits() {
        return this.sub.product_info.extended_info.membershipBenefits || [];
      },

      oneTimeBenefits() {
        return this.sub.product_info.extended_info.oneTimeBenefits || [];
      },

      frequencies() {
        return this.sub.product_type_sub_frequencies.split(',');
      },

      nextShipDates() {
        //- extracting the YYYY-MM-DD so that we can avoid daylight savings time trap when displaying correct day
        return (this.sub.nextDates || []).map(date => {
          return date.substring(0, 10).toString();
        });
      }
    },

    asyncComputed: {
      shouldOpenChangeColorModalViaUrlParam() {
        var shouldOpen = this.$root.urlParams.change && this.openChangeColorFromUrlParam && this.sub.id;
        return new Promise(resolve => {
          if (shouldOpen) {
            this.openChangeColorFromUrlParam = false;
            this.openChangeColorModal();
          }
          resolve(shouldOpen);
        });
      }
    },

    methods: {
      ...mapActions('subscriptions', [
        'openPostponeModal',
        'editAutoDeliveryAddressModal',
        'editAutoDeliveryPaymentModal',
        'editAutoDeliveryFrequencyModal',
        'editAutoDeliveryChangeColorModal',
        'editAutoDeliveryCancelModal',
        'updateSubscription',
        'shipNow'
      ]),

      enterCancelFlowv1() {
        this.editAutoDeliveryCancelModal({ subId: this.sub.id })
      },

      openChangeColorModal() {
        this.editAutoDeliveryChangeColorModal({ subId: this.sub.id, theme: this.changeColorTheme });
      },

      ...mapMutations('payments', ['setSelectedProfileId']),
      ...mapMutations('addressBook', ['setSelectedAddressId']),

      openEditAddressModal() {
        this.setSelectedAddressId(this.sub.shipping_address_id);
        this.editAutoDeliveryAddressModal({ subId: this.sub.id });
      },

      openEditPaymentModal() {
        this.setSelectedProfileId(this.sub.payment_id);
        this.editAutoDeliveryPaymentModal({ subId: this.sub.id });
      },

      setReactivateShipDate(date) {
        this.reactivateNext = date;
      },

      reactivateSubscription() {
        var payload = {
          sub_id: this.sub.id,
          changes: {
            status: 'active',
            next: getShortDateString(this.reactivateNext),
            frequency: this.reactivateFrequency,
            shipping_address_id: this.sub.shipping_address_id,
            payment_id: this.sub.payment_id
          }
        };

        this.updateSubscription(payload);
      }
    },

    beforeCreate() {
      this.$store.dispatch('subscriptions/initSubscriptions');
      this.$store.dispatch('addressBook/initAddresses');
      this.$store.dispatch('payments/initPaymentProfiles');
    },

    mounted() {
      if (this.$root.urlParams.change) {
        this.openChangeColorFromUrlParam = true;
      }
    }
  }
</script>

<style scoped lang="stylus">
  .edit-auto-delivery
    .subscription-product-wrap
      overflow visible !important

    .back
      &.secondary-back
        padding 1em
        position absolute

    .sub-wrap
      padding-bottom 1em

    .product-info-wrap
      padding 0.3em 0 0 1.5em

      .sub-product
        p
          color color-slate
        hr
          margin-top 2em
          border-color color-gray-med

    .mg-bottom
      margin-bottom 0.7em

    .attachments
      .sub-attachment
        border-bottom 1px solid color-gray-med

    .next-shipments
      padding 1.5em 0.6em 0.6em

      .next-shipments-title
        padding-top 0.5em

    .shipment-date
      &:not(:last-child)
        border-right 1px solid color-fog-light

    .image-overlay
      height 15em
      position absolute
      bottom 100%
      background rgb(0,0,0)
      background linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%)

    .shipping-details
      padding-top 2em

      .ship-detail-title
        padding-bottom 1em

    .address-title
    .payment-title
      padding-bottom 1em

    .action-section
      display flex
      align-items flex-start
      flex-wrap wrap
      justify-content space-between

      .action-block
        text-align center
        height 8em
        padding 1.2em
        cursor pointer
        setcolor(color-mr-purple)
        background-color #fff
        border-radius 8px
        border 1px solid #ebebeb
        flex-grow 1
        flex-basis auto
        margin 0.25em

        &:hover
          setcolor(color-mr-purple-lighter)

        &:first-child:nth-last-child(3), &:first-child:nth-last-child(3) ~ .action-block
          flex-basis: 0

    .reactivate-next
      padding-top 1em

    .reactivate-wrap
      margin-bottom 1em

      hr
        margin 2em 0

    .more-cta
      padding 1em

      .icon-caret-down
        display inline-block
        transition(transform 350ms ease)

      &.open
        .icon-caret-down
          transform(rotate(-180deg))

    @media mq-mobile
      .no-space-section
        margin-top 0 !important
        padding 0 !important

      .sub-wrap
        padding-top 0

      .product-info-wrap
        padding 0

        .sub-product
          position absolute
          bottom 100%
          padding 1em
          color #fff

          p
            color #fff

          hr
            display none

      .attachments
        padding 0 1em

      .frequency-wrap
        text-align right
        border-left 1px solid #fff

      .shipping-details
        padding 1em 1em 0

      .sub-ship-address
        padding-bottom 2em

      .action-block
        width 46%
        margin 2%

    @media mq-tablet
      #dashboard
        .section
          &.no-space-section
            margin-top 0
            padding 0

      .sub-wrap
        padding-top 0

      .product-info-wrap
        padding 0

        .sub-product
          position absolute
          bottom 100%
          padding 1em
          color #fff

          p
            color #fff

          hr
            display none

      .frequency-wrap
        text-align right
        border-left 1px solid #fff

      .sub-ship-address
        padding-bottom 2em

      .action-block
        width 46%
        margin 2%

</style>